var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterByIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4443 5.59465H10.6666V0.0942383H12.4443V1.92771H15.9998V3.76118H12.4443V5.59465ZM0 3.76051V1.92704H8.88871V3.76051H0ZM0 14.7619V12.9285H5.33322V14.7619H0ZM8.88907 16.5956V14.7621H16V12.9287H8.88907V11.0952H7.11133V16.5956H8.88907ZM3.55548 7.42767V5.5942H5.33322V11.0946H3.55548V9.26114H0V7.42767H3.55548ZM16 9.26203V7.42856H7.11133V9.26203H16Z",
    fill: "#2B56A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterByIcon);
export default __webpack_public_path__ + "static/media/filter-by-icon.70f0cbd838a2f6c40dfe04f3a1e50e10.svg";
export { ForwardRef as ReactComponent };